const isValidHex = (hexColor: string) => /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hexColor);

const getChunksFromString = (colorProp: string, chunkSize: number) => colorProp.match(new RegExp(`.{${chunkSize}}`, "g"));

const convertHexUnitTo256 = (hexStr: string) => parseInt(hexStr.repeat(2 / hexStr.length), 16);

const getAlphafloat = (initialAlpha: number, requestedAlpha: number) => {
	if (typeof initialAlpha !== "undefined") {
		return initialAlpha / 255;
	}
	if (typeof requestedAlpha != "number" || requestedAlpha < 0 || requestedAlpha > 1) {
		return 1;
	}
	return requestedAlpha;
};

const hexToRGBA = (hexColor: string, alpha: number): string => {
	if (!isValidHex(hexColor)) {
		throw new Error("Invalid HEX");
	}
	const chunkSize = Math.floor((hexColor.length - 1) / 3);
	const hexArr = getChunksFromString(hexColor.slice(1), chunkSize);

	if (!hexArr) {
		throw new Error(`hexToRGBA(${hexColor}[#HHEEXX], ${alpha}[0...1]) failed. Could not slice the hex property into rgb`);
	}

	const [r, g, b, a] = hexArr.map(convertHexUnitTo256);

	return `rgba(${r}, ${g}, ${b}, ${getAlphafloat(a, alpha)})`;
};

export default hexToRGBA;
